import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@roc/ui';
import { useEffect, useMemo, useRef, useState } from 'react';

const useStyles = makeStyles(() => ({
  title: {
    fontWeight: 700,
    fontSize: '18px',
    lineHeight: '157%',
    letterSpacing: '0.1px',
    color: '#333333',
  },
  label: {
    fontWeight: 400,
    fontSize: '16px',
    letterSpacing: '0.1px',
    color: '#848484',
  },
  value: {
    display: 'block',
    maxWidth: '200px',
    fontWeight: 700,
    fontSize: '16px',
    letterSpacing: '0.1px',
    wordBreak: 'break-word',
    color: '#333333',
  },
}));

function ValueWithEllipsis({ value }) {
  const classes = useStyles();

  const textRef = useRef<HTMLSpanElement>(null);
  const [isEllipsis, setIsEllipsis] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsEllipsis(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, [value]);

  return (
    <Tooltip title={isEllipsis ? value : ''} placement="top" arrow>
      <Typography
        variant='body1'
        component='span'
        noWrap
        className={classes.value}
        ref={textRef}
      >
        { value }
      </Typography>
    </Tooltip>
  );
};

export default function KeyInformationDetailItem({ title, items }) {
  const classes = useStyles();

  const labelContainerWidth = useMemo(() => {
    const maxChars = Math.max(...items.map(item => item.label.length)) + 3;
    return `calc(${maxChars} * 16px / 2)`;
  }, [items]);

  return (
    <Grid container direction='column' spacing={2}>
      <Grid item>
        <Typography variant='h5' component='h5' className={classes.title}>
          { title }
        </Typography>
      </Grid>
      <Grid item container direction='column' spacing={1}>
        {items.map((item, index) => (
          <Grid item key={index}>
            <Grid container direction='row' spacing={1}>
              <Grid item style={{ width: labelContainerWidth }}>
                <Typography
                  variant='body1'
                  component='span'
                  className={classes.label}
                >
                  { item.label }:
                </Typography>
              </Grid>
              <Grid item>
                <ValueWithEllipsis value={item.value} />
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
